import { useBrowseNotificationsCountApi } from '../api/use-browse-notifications-count-api';
import { NotificationStatus } from '../types';

export function useNotificationsCount(
  value: NotificationStatus,
  disabled?: boolean
) {
  const api = useBrowseNotificationsCountApi(NotificationStatus.ALL);
  const data = api.data ?? [];
  if (disabled) return null;

  const totalCount = data.reduce((sum, item) => sum + item.count, 0);

  const statusCounts = data.reduce<Record<string, number>>((acc, item) => {
    acc[item.status] = (acc[item.status] || 0) + item.count;
    return acc;
  }, {});

  if (value === NotificationStatus.ALL) return totalCount;

  return statusCounts[value];
}
